'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';

export class NavbarComponent {
    menu = [{
        title: 'Home',
        state: 'main'
    }];
    isLoggedIn: Function;
    isAdmin: Function;
    getCurrentUser: Function;
    isCollapsed = true;

    constructor(Auth, $state, $anchorScroll, searchService, $location, $http, $scope) {
        'ngInject';

        this.isLoggedIn = Auth.isLoggedInSync;
        this.isAdmin = Auth.isAdminSync;
        this.getCurrentUser = Auth.getCurrentUserSync;
        this.$anchorScroll = $anchorScroll;
        this.$state = $state;
        this.searchService = searchService;
        this.$location = $location;
        this.$http = $http;
        this.$scope = $scope;
    }
    $onInit() {
        var key;
        this.$scope.baseURL = this.searchService.getBaseURL();

        if (this.searchService.getKey()) {
            key = this.searchService.getKey();
            console.log(key, ' is the key in nav');
            this.$location.search('key', key);
        }

        // Check if key exists in URL params and set it in service
        if (this.$location.search().key) {
            key = this.$location.search().key;
            console.log(key);
            this.searchService.setKey(key);
        }

        //Check key for nav access
        this.$http.get(`${this.$scope.baseURL}/api/cw/client/${key}`)
            .then(response => {
                this.$scope.client = response.data[0];
            });

        if (this.$state.current.name === '') {
            console.log('this is main');
        }
    }
    loadCollection(type) {
        console.log(this.$state.current.name);
        if (this.$state.current.name === '' || this.$state.current.name === 'main') {
            console.log('this is the main view');
            this.$location.url('/#' + type);
            this.$anchorScroll(type);
            if (this.searchService.getKey()) {
                this.key = this.searchService.getKey();
                console.log(this.key);
                this.$location.search('key', this.key);
            }
        } else {
            // this.$state.go('main');
            this.$location.url('/#' + type);
            this.$anchorScroll(type);
        }

    }

}

export default angular.module('directives.navbar', [])
    .component('navbar', {
        template: require('./navbar.html'),
        controller: NavbarComponent
    })
    .name;


// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js